<div class="bar_chart" *ngIf="!noData">
   <div style="display: block;">
       <canvas #chartCanvas></canvas>
   </div>
</div>

<div *ngIf="noData" class="no-data-container">
   <img src="assets/images/financials/no-data-image.svg" alt="No data" />
   <p>No Chart Data Available!</p>
</div>
